(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["glo-provider-locator"] && !Shopify.designMode) return;
  try {
    
(() => {
  const ELEMENT_NAME = 'glo-provider-locator';
  const MILES_PER_KILOMETRE = 0.621371;
  const EARTH_RADIUS_KM = 6371.0088;

  const escapeHtml = (value = '') => String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');

  const cleanText = (value) => value === null || value === undefined ? '' : String(value).trim();
  const normaliseText = (value) => cleanText(value)
    .toLocaleLowerCase('en-GB')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, ' ')
    .trim();

  const numberValue = (value) => {
    const parsed = Number.parseFloat(value);
    return Number.isFinite(parsed) ? parsed : null;
  };

  const booleanValue = (value) => value === true || value === 1 || value === '1' || String(value).toLowerCase() === 'true';

  const safeHttpUrl = (value) => {
    const text = cleanText(value);
    if (!text) return '';
    try {
      let candidate;
      if (text.startsWith('//')) candidate = `https:${text}`;
      else if (text.startsWith('/')) candidate = new URL(text, window.location.origin).href;
      else candidate = /^[a-z][a-z0-9+.-]*:/i.test(text) ? text : `https://${text}`;
      const url = new URL(candidate, window.location.origin);
      return ['http:', 'https:'].includes(url.protocol) ? url.href : '';
    } catch (_error) {
      return '';
    }
  };

  const getFirst = (object, keys, fallback = '') => {
    for (const key of keys) {
      if (object && object[key] !== undefined && object[key] !== null && object[key] !== '') return object[key];
    }
    return fallback;
  };

  const waitForLeaflet = (timeout = 12000) => new Promise((resolve, reject) => {
    if (window.L && typeof window.L.map === 'function') {
      resolve(window.L);
      return;
    }

    const started = Date.now();
    const timer = window.setInterval(() => {
      if (window.L && typeof window.L.map === 'function') {
        window.clearInterval(timer);
        resolve(window.L);
      } else if (Date.now() - started >= timeout) {
        window.clearInterval(timer);
        reject(new Error('Leaflet did not load.'));
      }
    }, 60);
  });

  class GloProviderLocator extends HTMLElement {
    connectedCallback() {
      if (this.initialised || this.initialising) return;
      this.initialising = true;
      this.initialise().catch((error) => {
        console.error('[Glo provider locator]', error);
        this.showNotice('The provider map could not be loaded. Please refresh the page or try again later.', 'error');
        this.setLoading(false);
      }).finally(() => {
        this.initialising = false;
      });
    }

    disconnectedCallback() {
      this.destroy();
    }

    async initialise() {
      this.cacheElements();
      this.readConfiguration();
      this.bindEvents();
      this.setLoading(true);

      const inlineProviders = this.parseInlineProviders();
      let feedProviders = [];

      if (this.config.jsonFeedUrl) {
        try {
          feedProviders = await this.loadJsonFeed(this.config.jsonFeedUrl);
        } catch (error) {
          console.warn('[Glo provider locator] JSON feed could not be loaded.', error);
          this.showNotice('Some provider data could not be loaded. Showing the providers available in Shopify.', 'error');
        }
      }

      this.providers = this.dedupeProviders([...inlineProviders, ...feedProviders]
        .map((provider, index) => this.normaliseProvider(provider, index))
        .filter(Boolean));

      this.buildSuggestions();
      this.L = await waitForLeaflet();
      this.createMap();
      this.restoreUrlState();
      this.initialised = true;

      if (this.input.value.trim()) {
        await this.performSearch({ updateUrl: false });
      } else {
        this.renderInitialState();
      }

      this.setLoading(false);
      window.setTimeout(() => this.map?.invalidateSize(), 80);
    }

    cacheElements() {
      this.form = this.querySelector('[data-locator-form]');
      this.input = this.querySelector('[data-locator-input]');
      this.suggestions = this.querySelector('[data-locator-suggestions]');
      this.locationButton = this.querySelector('[data-location-button]');
      this.clearButton = this.querySelector('[data-clear-search]');
      this.resultsArea = this.querySelector('[data-results-area]');
      this.resultsHeading = this.querySelector('[data-results-heading]');
      this.resultsCount = this.querySelector('[data-results-count]');
      this.resultsList = this.querySelector('[data-results-list]');
      this.mapElement = this.querySelector('[data-locator-map]');
      this.mapLoading = this.querySelector('[data-map-loading]');
      this.notice = this.querySelector('[data-locator-notice]');
      this.dataScript = this.querySelector('[data-glo-provider-data]');
      this.markerSvgSource = this.querySelector('[data-marker-svg-source]');
    }

    readConfiguration() {
      const data = this.dataset;
      this.config = {
        startLat: numberValue(data.mapStartLat) ?? 54.5,
        startLng: numberValue(data.mapStartLng) ?? -3,
        startZoom: numberValue(data.mapStartZoom) ?? 5,
        tileUrl: cleanText(data.tileUrl) || 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
        tileAttribution: cleanText(data.tileAttribution) || '&copy; OpenStreetMap contributors',
        jsonFeedUrl: safeHttpUrl(data.jsonFeedUrl),
        resultLimit: Math.max(1, Math.round(numberValue(data.resultLimit) ?? 8)),
        resultsLabel: cleanText(data.resultsLabel) || 'providers found',
        resultsHeading: cleanText(data.resultsHeading) || 'Your nearest Glo dentists',
        noResultsText: cleanText(data.noResultsText) || 'No providers were found within that distance.',
        searchErrorText: cleanText(data.searchErrorText) || 'We could not identify that location.',
        directionsLabel: cleanText(data.directionsLabel) || 'Directions',
        bookLabel: cleanText(data.bookLabel) || 'Book consultation',
        websiteLabel: cleanText(data.websiteLabel) || 'Visit website',
        callLabel: cleanText(data.callLabel) || 'Call practice',
        featuredLabel: cleanText(data.featuredLabel) || 'Featured provider',
        cardColorScheme: cleanText(data.cardColorScheme),
        markerImageUrl: safeHttpUrl(data.markerImageUrl),
        markerSvgCode: cleanText(this.markerSvgSource?.value),
        markerWidth: Math.max(24, Math.min(100, Math.round(numberValue(data.markerWidth) ?? 44))),
        markerHeight: Math.max(28, Math.min(120, Math.round(numberValue(data.markerHeight) ?? 56))),
        syncUrl: data.syncUrl === 'true',
        primaryColor: getComputedStyle(this).getPropertyValue('--color-btn-primary').trim() || '#2474ff'
      };

      this.geocodeCache = new Map();
      this.markerById = new Map();
      this.cardById = new Map();
      this.searchToken = 0;
    }

    bindEvents() {
      this.onSubmit = (event) => {
        event.preventDefault();
        this.performSearch();
      };
      this.onLocationClick = () => this.useCurrentLocation();
      this.onClearClick = () => this.clearSearch();
      this.onInputKeydown = (event) => {
        if (event.key === 'Escape' && this.input.value) this.clearSearch();
      };

      this.form?.addEventListener('submit', this.onSubmit);
      this.locationButton?.addEventListener('click', this.onLocationClick);
      this.clearButton?.addEventListener('click', this.onClearClick);
      this.input?.addEventListener('keydown', this.onInputKeydown);
    }

    destroy() {
      this.form?.removeEventListener('submit', this.onSubmit);
      this.locationButton?.removeEventListener('click', this.onLocationClick);
      this.clearButton?.removeEventListener('click', this.onClearClick);
      this.input?.removeEventListener('keydown', this.onInputKeydown);

      if (this.map) {
        this.map.remove();
        this.map = null;
      }

      this.initialised = false;
      this.markerById?.clear();
      this.cardById?.clear();
    }

    parseInlineProviders() {
      if (!this.dataScript) return [];
      try {
        const data = JSON.parse(this.dataScript.textContent || '[]');
        return Array.isArray(data) ? data : [];
      } catch (error) {
        console.error('[Glo provider locator] Invalid provider JSON.', error);
        return [];
      }
    }

    async loadJsonFeed(url) {
      const payload = await this.fetchJson(url, 10000);
      if (Array.isArray(payload)) return payload;
      if (payload && Array.isArray(payload.providers)) return payload.providers;
      if (payload && Array.isArray(payload.data)) return payload.data;
      throw new Error('JSON feed must contain a provider array.');
    }

    normaliseProvider(provider, index) {
      if (!provider || typeof provider !== 'object') return null;

      const lat = numberValue(getFirst(provider, ['lat', 'latitude']));
      const lng = numberValue(getFirst(provider, ['lng', 'lon', 'longitude']));
      const practiceName = cleanText(getFirst(provider, ['practiceName', 'practice_name', 'name', 'practice']));

      if (!practiceName || lat === null || lng === null || Math.abs(lat) > 90 || Math.abs(lng) > 180) return null;

      const idSource = cleanText(getFirst(provider, ['id', 'handle', 'slug'])) || `${practiceName}-${lat}-${lng}-${index}`;
      const providerId = idSource.replace(/[^a-zA-Z0-9_-]+/g, '-').replace(/^-+|-+$/g, '') || `provider-${index}`;

      const result = {
        id: providerId,
        practiceName,
        dentistName: cleanText(getFirst(provider, ['dentistName', 'dentist_name', 'providerName', 'provider_name'])),
        address1: cleanText(getFirst(provider, ['address1', 'address_line_1', 'address'])),
        address2: cleanText(getFirst(provider, ['address2', 'address_line_2'])),
        town: cleanText(getFirst(provider, ['town', 'townCity', 'town_city', 'city'])),
        county: cleanText(getFirst(provider, ['county', 'region'])),
        postcode: cleanText(getFirst(provider, ['postcode', 'postalCode', 'postal_code'])).toUpperCase(),
        lat,
        lng,
        phone: cleanText(getFirst(provider, ['phone', 'telephone', 'phoneNumber', 'phone_number'])),
        email: cleanText(getFirst(provider, ['email', 'emailAddress', 'email_address'])),
        website: safeHttpUrl(getFirst(provider, ['website', 'websiteUrl', 'website_url'])),
        bookingUrl: safeHttpUrl(getFirst(provider, ['bookingUrl', 'booking_url', 'bookUrl', 'book_url'])),
        logoUrl: safeHttpUrl(getFirst(provider, ['logoUrl', 'logo_url', 'logo'])),
        featured: booleanValue(getFirst(provider, ['featured', 'isFeatured', 'is_featured'], false)),
        keywords: cleanText(getFirst(provider, ['keywords', 'searchKeywords', 'search_keywords'])),
        distance: null
      };

      result.searchText = normaliseText([
        result.practiceName,
        result.dentistName,
        result.address1,
        result.address2,
        result.town,
        result.county,
        result.postcode,
        result.keywords
      ].filter(Boolean).join(' '));

      return result;
    }

    dedupeProviders(providers) {
      const seen = new Map();
      providers.forEach((provider) => {
        const key = normaliseText(`${provider.practiceName}|${provider.postcode}|${provider.lat.toFixed(5)}|${provider.lng.toFixed(5)}`);
        if (!seen.has(key)) seen.set(key, provider);
      });
      return [...seen.values()];
    }

    buildSuggestions() {
      if (!this.suggestions) return;
      const values = new Set();
      this.providers.forEach((provider) => {
        [provider.practiceName, provider.town, provider.postcode].filter(Boolean).forEach((value) => values.add(value));
      });

      const fragment = document.createDocumentFragment();
      [...values].sort((a, b) => a.localeCompare(b, 'en-GB')).slice(0, 750).forEach((value) => {
        const option = document.createElement('option');
        option.value = value;
        fragment.appendChild(option);
      });
      this.suggestions.replaceChildren(fragment);
    }

    createMap() {
      this.map = this.L.map(this.mapElement, {
        center: [this.config.startLat, this.config.startLng],
        zoom: this.config.startZoom,
        scrollWheelZoom: false,
        zoomControl: true,
        attributionControl: true
      });

      this.L.tileLayer(this.config.tileUrl, {
        attribution: this.config.tileAttribution,
        maxZoom: 19,
        minZoom: 3
      }).addTo(this.map);

      this.markerLayer = this.L.layerGroup().addTo(this.map);
      this.searchLayer = this.L.layerGroup().addTo(this.map);
      this.map.once('load', () => this.mapLoading?.setAttribute('hidden', ''));
      this.map.whenReady(() => this.mapLoading?.setAttribute('hidden', ''));
    }

    restoreUrlState() {
      if (!this.config.syncUrl) return;
      const params = new URLSearchParams(window.location.search);
      const query = params.get('glo_location');
      if (query) this.input.value = query;
    }

    updateUrlState(query = '') {
      if (!this.config.syncUrl || !window.history?.replaceState) return;
      const url = new URL(window.location.href);
      if (query) url.searchParams.set('glo_location', query);
      else url.searchParams.delete('glo_location');
      url.searchParams.delete('glo_radius');
      window.history.replaceState({}, '', `${url.pathname}${url.search}${url.hash}`);
    }

    async performSearch({ updateUrl = true } = {}) {
      const query = cleanText(this.input.value);
      const token = ++this.searchToken;

      if (!query && !this.currentOrigin) {
        this.clearNotice();
        this.updateUrlState('');
        this.renderInitialState();
        return;
      }

      this.setLoading(true);
      this.clearNotice();

      try {
        const textMatches = query ? this.findTextMatches(query) : [];
        const origin = this.currentOrigin && !query ? this.currentOrigin : await this.resolveSearchOrigin(query, textMatches);
        if (token !== this.searchToken) return;

        let results;
        if (origin) {
          results = this.providers
            .map((provider) => ({ ...provider, distance: this.distanceMiles(origin.lat, origin.lng, provider.lat, provider.lng) }))
            .sort((a, b) => a.distance - b.distance || Number(b.featured) - Number(a.featured) || a.practiceName.localeCompare(b.practiceName, 'en-GB'))
            .slice(0, this.config.resultLimit);
          this.currentOrigin = origin;
        } else {
          results = textMatches.slice(0, this.config.resultLimit).map((provider) => ({ ...provider, distance: null }));
          this.currentOrigin = null;
        }

        if (!origin && !results.length) this.showNotice(this.config.searchErrorText, 'error');

        this.renderResults(results, origin);
        if (updateUrl) this.updateUrlState(query);
      } catch (error) {
        console.warn('[Glo provider locator] Search failed.', error);
        const fallback = this.findTextMatches(query).slice(0, this.config.resultLimit);
        this.currentOrigin = null;
        this.renderResults(fallback, null);
        if (!fallback.length) this.showNotice(this.config.searchErrorText, 'error');
      } finally {
        if (token === this.searchToken) this.setLoading(false);
      }
    }

    findTextMatches(query) {
      const normalisedQuery = normaliseText(query);
      if (!normalisedQuery) return [];

      return this.providers
        .map((provider) => ({ provider, score: this.textMatchScore(provider, normalisedQuery) }))
        .filter((item) => item.score > 0)
        .sort((a, b) => b.score - a.score || Number(b.provider.featured) - Number(a.provider.featured) || a.provider.practiceName.localeCompare(b.provider.practiceName, 'en-GB'))
        .map((item) => ({ ...item.provider, distance: null }));
    }

    textMatchScore(provider, query) {
      const practice = normaliseText(provider.practiceName);
      const dentist = normaliseText(provider.dentistName);
      const town = normaliseText(provider.town);
      const postcode = normaliseText(provider.postcode);

      if (practice === query) return 120;
      if (dentist && dentist === query) return 115;
      if (postcode === query) return 110;
      if (town === query) return 105;
      if (practice.startsWith(query)) return 95;
      if (dentist && dentist.startsWith(query)) return 90;
      if (postcode.startsWith(query)) return 88;
      if (town.startsWith(query)) return 85;
      if (practice.includes(query)) return 80;
      if (dentist && dentist.includes(query)) return 76;
      if (provider.searchText.includes(query)) return 50;
      return 0;
    }

    async resolveSearchOrigin(query, textMatches) {
      if (!query) return this.currentOrigin;
      const normalisedQuery = normaliseText(query);
      const topMatch = textMatches[0];

      if (topMatch && this.textMatchScore(topMatch, normalisedQuery) >= 90) {
        return { lat: topMatch.lat, lng: topMatch.lng, label: topMatch.practiceName, type: 'provider' };
      }

      const localPlaceMatches = this.providers.filter((provider) => {
        const town = normaliseText(provider.town);
        const county = normaliseText(provider.county);
        const postcode = normaliseText(provider.postcode);
        return town === normalisedQuery || county === normalisedQuery || postcode === normalisedQuery || postcode.startsWith(normalisedQuery);
      });

      if (localPlaceMatches.length) {
        const centre = this.averageCoordinates(localPlaceMatches);
        return { ...centre, label: query, type: 'local-place' };
      }

      const cacheKey = normaliseText(query);
      if (this.geocodeCache.has(cacheKey)) return this.geocodeCache.get(cacheKey);

      let origin = null;
      if (this.looksLikePostcode(query)) origin = await this.geocodePostcode(query);
      if (!origin) origin = await this.geocodePlace(query);

      if (!origin && topMatch) {
        origin = { lat: topMatch.lat, lng: topMatch.lng, label: topMatch.practiceName, type: 'text-match' };
      }

      this.geocodeCache.set(cacheKey, origin);
      return origin;
    }

    looksLikePostcode(query) {
      const compact = cleanText(query).toUpperCase().replace(/\s+/g, '');
      return /^[A-Z]{1,2}\d[A-Z\d]?(?:\d[A-Z]{2})?$/.test(compact) || compact === 'GIR0AA';
    }

    async geocodePostcode(query) {
      const compact = cleanText(query).toUpperCase().replace(/\s+/g, '');
      const isFullPostcode = /\d[A-Z]{2}$/.test(compact);
      const endpoint = isFullPostcode
        ? `https://api.postcodes.io/postcodes/${encodeURIComponent(compact)}`
        : `https://api.postcodes.io/outcodes/${encodeURIComponent(compact)}`;

      try {
        const payload = await this.fetchJson(endpoint, 7000);
        const result = payload?.result;
        const lat = numberValue(result?.latitude);
        const lng = numberValue(result?.longitude);
        if (lat === null || lng === null) return null;
        return {
          lat,
          lng,
          label: cleanText(result?.postcode || result?.outcode || query),
          type: isFullPostcode ? 'postcode' : 'outcode'
        };
      } catch (_error) {
        return null;
      }
    }

    async geocodePlace(query) {
      try {
        const payload = await this.fetchJson(`https://api.postcodes.io/places?q=${encodeURIComponent(query)}&limit=10`, 7000);
        const results = Array.isArray(payload?.result) ? payload.result : [];

        if (results.length) {
          const queryText = normaliseText(query);
          const scored = results.map((result) => {
            const names = [result.name_1, result.name_2, result.local_type, result.county_unitary, result.region].filter(Boolean);
            const exact = names.some((name) => normaliseText(name) === queryText);
            const starts = names.some((name) => normaliseText(name).startsWith(queryText));
            return { result, score: exact ? 2 : starts ? 1 : 0 };
          }).sort((a, b) => b.score - a.score);

          const place = scored[0]?.result;
          const lat = numberValue(place?.latitude);
          const lng = numberValue(place?.longitude);
          if (lat !== null && lng !== null) {
            return {
              lat,
              lng,
              label: cleanText(place?.name_1 || place?.name_2 || query),
              type: 'place'
            };
          }
        }
      } catch (_error) {
        // Fall through to the OpenStreetMap lookup below.
      }

      try {
        const payload = await this.fetchJson(`https://nominatim.openstreetmap.org/search?format=jsonv2&countrycodes=gb&limit=5&addressdetails=1&q=${encodeURIComponent(`${query}, United Kingdom`)}`, 8000);
        const results = Array.isArray(payload) ? payload : [];
        const place = results[0];
        const lat = numberValue(place?.lat);
        const lng = numberValue(place?.lon);
        if (lat === null || lng === null) return null;

        const address = place.address || {};
        return {
          lat,
          lng,
          label: cleanText(address.town || address.city || address.village || address.municipality || address.county || query),
          type: 'place'
        };
      } catch (_error) {
        return null;
      }
    }

    averageCoordinates(providers) {
      const total = providers.reduce((sum, provider) => ({ lat: sum.lat + provider.lat, lng: sum.lng + provider.lng }), { lat: 0, lng: 0 });
      return { lat: total.lat / providers.length, lng: total.lng / providers.length };
    }

    distanceMiles(lat1, lng1, lat2, lng2) {
      const toRadians = (degrees) => degrees * Math.PI / 180;
      const deltaLat = toRadians(lat2 - lat1);
      const deltaLng = toRadians(lng2 - lng1);
      const a = Math.sin(deltaLat / 2) ** 2
        + Math.cos(toRadians(lat1)) * Math.cos(toRadians(lat2)) * Math.sin(deltaLng / 2) ** 2;
      const distanceKm = 2 * EARTH_RADIUS_KM * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      return distanceKm * MILES_PER_KILOMETRE;
    }

    renderInitialState() {
      this.visibleResults = [];
      this.cardById.clear();
      this.resultsList.replaceChildren();
      this.clearMarkers();
      this.searchLayer?.clearLayers();
      this.resultsArea.hidden = true;
      this.clearButton.hidden = true;
      this.resultsList.setAttribute('aria-busy', 'false');
      this.map?.setView([this.config.startLat, this.config.startLng], this.config.startZoom, { animate: false });
      window.setTimeout(() => this.map?.invalidateSize(), 40);
    }

    renderResults(results, origin) {
      this.visibleResults = results;
      this.cardById.clear();
      this.resultsList.replaceChildren();
      this.clearMarkers();
      this.resultsArea.hidden = false;

      const countText = results.length === 1 ? '1 provider found' : `${results.length} ${this.config.resultsLabel}`;
      const locationLabel = cleanText(origin?.label);
      this.resultsHeading.textContent = this.config.resultsHeading;
      this.resultsCount.textContent = locationLabel ? `${locationLabel} · ${countText}` : countText;
      this.resultsList.setAttribute('aria-busy', 'false');
      this.clearButton.hidden = !this.input.value.trim() && !this.currentOrigin;

      if (!results.length) {
        this.renderEmptyState();
      } else {
        const fragment = document.createDocumentFragment();
        results.forEach((provider) => {
          const card = this.createProviderCard(provider);
          fragment.appendChild(card);
          this.cardById.set(provider.id, card);
          this.addProviderMarker(provider);
        });
        this.resultsList.appendChild(fragment);
      }

      this.updateSearchOverlay(origin);
      this.updateMapView(results, origin);
      window.setTimeout(() => this.map?.invalidateSize(), 40);
    }

    renderEmptyState() {
      const wrapper = document.createElement('div');
      wrapper.className = 'glo-provider-locator__empty';
      if (this.config.cardColorScheme) wrapper.setAttribute('color-scheme', this.config.cardColorScheme);
      wrapper.innerHTML = `
        <div class="glo-provider-locator__empty-inner">
          <span class="glo-provider-locator__empty-icon" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><path d="M20 10c0 5-8 11-8 11S4 15 4 10a8 8 0 1 1 16 0Z"/><circle cx="12" cy="10" r="2.5"/></svg>
          </span>
          <p>${escapeHtml(this.config.noResultsText)}</p>
        </div>`;
      this.resultsList.appendChild(wrapper);
    }

    createProviderCard(provider) {
      const card = document.createElement('article');
      card.className = 'glo-provider-locator__card';
      if (this.config.cardColorScheme) card.setAttribute('color-scheme', this.config.cardColorScheme);
      card.dataset.providerId = provider.id;
      card.tabIndex = 0;

      const initials = provider.practiceName.split(/\s+/).slice(0, 2).map((word) => word.charAt(0)).join('').toUpperCase();
      const logo = provider.logoUrl
        ? `<img src="${escapeHtml(provider.logoUrl)}" alt="" width="112" height="112" loading="lazy">`
        : escapeHtml(initials || 'G');
      const distance = Number.isFinite(provider.distance)
        ? `<span class="glo-provider-locator__distance">${this.formatDistance(provider.distance)}</span>`
        : '';
      const featured = provider.featured
        ? `<span class="glo-provider-locator__featured">${escapeHtml(this.config.featuredLabel)}</span>`
        : '';
      const dentist = provider.dentistName
        ? `<p class="glo-provider-locator__dentist">${escapeHtml(provider.dentistName)}</p>`
        : '';
      const address = this.providerAddress(provider);
      const actions = this.providerActions(provider);

      card.innerHTML = `
        <div class="glo-provider-locator__card-logo">${logo}</div>
        <div class="glo-provider-locator__card-body">
          <div class="glo-provider-locator__card-topline">
            <h3 class="glo-provider-locator__card-title">${escapeHtml(provider.practiceName)}</h3>
            ${distance}
          </div>
          ${featured}
          ${dentist}
          ${address ? `<p class="glo-provider-locator__address">${escapeHtml(address)}</p>` : ''}
          ${actions ? `<div class="glo-provider-locator__card-actions">${actions}</div>` : ''}
        </div>`;

      card.addEventListener('click', (event) => {
        if (event.target.closest('a, button')) return;
        this.focusProvider(provider.id, { scrollCard: false });
      });
      card.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          this.focusProvider(provider.id, { scrollCard: false });
        }
      });

      return card;
    }

    providerActions(provider) {
      const links = [];
      const address = this.providerAddress(provider);
      const destination = address || `${provider.lat},${provider.lng}`;
      const directionsUrl = `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(destination)}`;
      links.push(`<a class="glo-provider-locator__card-link" href="${directionsUrl}" target="_blank" rel="noopener">${escapeHtml(this.config.directionsLabel)}</a>`);

      if (provider.bookingUrl) {
        links.push(`<a class="glo-provider-locator__card-link glo-provider-locator__card-link--primary" href="${escapeHtml(provider.bookingUrl)}" target="_blank" rel="noopener">${escapeHtml(this.config.bookLabel)}</a>`);
      } else if (provider.website) {
        links.push(`<a class="glo-provider-locator__card-link glo-provider-locator__card-link--primary" href="${escapeHtml(provider.website)}" target="_blank" rel="noopener">${escapeHtml(this.config.websiteLabel)}</a>`);
      }

      const telephone = provider.phone.replace(/[^+\d]/g, '');
      if (telephone) links.push(`<a class="glo-provider-locator__card-link" href="tel:${escapeHtml(telephone)}">${escapeHtml(this.config.callLabel)}</a>`);
      return links.join('');
    }

    providerAddress(provider) {
      return [provider.address1, provider.address2, provider.town, provider.county, provider.postcode].filter(Boolean).join(', ');
    }

    formatDistance(distance) {
      if (distance < 0.1) return '<0.1 miles';
      return `${distance < 10 ? distance.toFixed(1) : Math.round(distance)} miles`;
    }

    defaultMarkerSvg() {
      return `
        <svg viewBox="0 0 64 82" aria-hidden="true" focusable="false">
          <path class="glo-provider-locator__marker-default-path" d="M32 4C18.745 4 8 14.745 8 28c0 8.252 3.588 15.013 8.157 21.078 5.339 7.085 11.943 13.501 14.696 24.135.162.625.699 1.062 1.147 1.062s.985-.437 1.147-1.062c2.753-10.634 9.357-17.05 14.696-24.135C52.412 43.013 56 36.252 56 28 56 14.745 45.255 4 32 4Z"/>
        </svg>`;
    }

    sanitiseMarkerSvg(svgCode) {
      const source = cleanText(svgCode);
      if (!source) return '';

      try {
        const documentNode = new DOMParser().parseFromString(source, 'image/svg+xml');
        const svg = documentNode.documentElement;
        if (!svg || svg.nodeName.toLowerCase() !== 'svg' || documentNode.querySelector('parsererror')) return '';

        documentNode.querySelectorAll('script, foreignObject, iframe, object, embed').forEach((node) => node.remove());
        documentNode.querySelectorAll('*').forEach((node) => {
          [...node.attributes].forEach((attribute) => {
            const name = attribute.name.toLowerCase();
            const value = attribute.value.trim().toLowerCase();
            if (name.startsWith('on') || value.startsWith('javascript:')) node.removeAttribute(attribute.name);
          });
        });

        svg.removeAttribute('width');
        svg.removeAttribute('height');
        svg.setAttribute('aria-hidden', 'true');
        svg.setAttribute('focusable', 'false');
        return new XMLSerializer().serializeToString(svg);
      } catch (_error) {
        return '';
      }
    }

    markerArtworkHtml() {
      const customSvg = this.sanitiseMarkerSvg(this.config.markerSvgCode);
      if (customSvg) return customSvg;
      if (this.config.markerImageUrl) {
        return `<img src="${escapeHtml(this.config.markerImageUrl)}" alt="" loading="lazy">`;
      }
      return this.defaultMarkerSvg();
    }

    markerHtml() {
      const width = this.config.markerWidth;
      const height = this.config.markerHeight;
      return `<span class="glo-provider-locator__marker-wrap" style="--glo-custom-marker-width:${width}px;--glo-custom-marker-height:${height}px"><span class="glo-provider-locator__marker-artwork">${this.markerArtworkHtml()}</span></span>`;
    }

    originMarkerHtml() {
      return '<span class="glo-provider-locator__origin-dot-wrap"><span class="glo-provider-locator__origin-dot"></span></span>';
    }

    addProviderMarker(provider) {
      const icon = this.L.divIcon({
        className: 'glo-provider-locator__marker-shell',
        html: this.markerHtml(),
        iconSize: [this.config.markerWidth, this.config.markerHeight],
        iconAnchor: [this.config.markerWidth / 2, this.config.markerHeight - 2],
        popupAnchor: [0, -(this.config.markerHeight - 8)]
      });

      const marker = this.L.marker([provider.lat, provider.lng], {
        icon,
        title: provider.practiceName,
        keyboard: true
      }).addTo(this.markerLayer);

      const address = this.providerAddress(provider);
      marker.bindPopup(`
        <strong class="glo-provider-locator__popup-title">${escapeHtml(provider.practiceName)}</strong>
        ${address ? `<span class="glo-provider-locator__popup-address">${escapeHtml(address)}</span>` : ''}
      `, { closeButton: true, maxWidth: 300 });

      marker.on('click', () => this.focusProvider(provider.id, { scrollCard: true, openPopup: false }));
      this.markerById.set(provider.id, marker);
    }

    clearMarkers() {
      this.markerLayer?.clearLayers();
      this.markerById?.clear();
    }

    updateSearchOverlay(origin) {
      this.searchLayer?.clearLayers();
      if (!origin) return;

      const originIcon = this.L.divIcon({
        className: 'glo-provider-locator__origin-marker-shell',
        html: this.originMarkerHtml(),
        iconSize: [32, 32],
        iconAnchor: [16, 16]
      });
      this.L.marker([origin.lat, origin.lng], { icon: originIcon, interactive: false }).addTo(this.searchLayer);
    }

    updateMapView(results, origin) {
      if (!this.map) return;
      const points = results.map((provider) => [provider.lat, provider.lng]);
      if (origin) points.push([origin.lat, origin.lng]);

      if (points.length > 1) {
        this.map.fitBounds(this.L.latLngBounds(points), { padding: [42, 42], maxZoom: 12, animate: false });
      } else if (points.length === 1) {
        this.map.setView(points[0], 13, { animate: false });
      } else {
        this.map.setView([this.config.startLat, this.config.startLng], this.config.startZoom, { animate: false });
      }
    }

    focusProvider(providerId, { scrollCard = true, openPopup = true } = {}) {
      this.cardById.forEach((card) => card.classList.toggle('is-active', card.dataset.providerId === providerId));
      this.markerById.forEach((marker, id) => {
        const element = marker.getElement();
        element?.classList.toggle('is-active', id === providerId);
      });

      const marker = this.markerById.get(providerId);
      const card = this.cardById.get(providerId);
      if (marker) {
        this.map.panTo(marker.getLatLng(), { animate: true, duration: 0.35 });
        if (openPopup) marker.openPopup();
      }
      if (scrollCard && card) card.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }

    async useCurrentLocation() {
      if (!navigator.geolocation) {
        this.showNotice('Location services are not available in this browser.', 'error');
        return;
      }

      this.setLoading(true);
      this.clearNotice();
      navigator.geolocation.getCurrentPosition(
        (position) => {
          this.input.value = '';
          this.currentOrigin = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
            label: 'Current location',
            type: 'geolocation'
          };
          this.performSearch();
        },
        (error) => {
          const message = error.code === error.PERMISSION_DENIED
            ? 'Location access was declined. Search using a postcode, town or city instead.'
            : 'Your location could not be determined. Search using a postcode, town or city instead.';
          this.showNotice(message, 'error');
          this.setLoading(false);
        },
        { enableHighAccuracy: false, timeout: 10000, maximumAge: 300000 }
      );
    }

    clearSearch() {
      this.searchToken += 1;
      this.input.value = '';
      this.currentOrigin = null;
      this.clearNotice();
      this.updateUrlState('');
      this.renderInitialState();
      this.input.focus();
    }

    setLoading(loading) {
      this.setAttribute('aria-busy', String(Boolean(loading)));
      this.resultsList?.setAttribute('aria-busy', String(Boolean(loading)));
      const submit = this.querySelector('[data-search-button]');
      if (submit) submit.disabled = Boolean(loading);
      if (this.locationButton) this.locationButton.disabled = Boolean(loading);
    }

    showNotice(message, type = 'info') {
      if (!this.notice || !message) return;
      this.notice.textContent = message;
      this.notice.dataset.type = type;
      this.notice.hidden = false;
    }

    clearNotice() {
      if (!this.notice) return;
      this.notice.textContent = '';
      this.notice.removeAttribute('data-type');
      this.notice.hidden = true;
    }

    async fetchJson(url, timeout = 8000) {
      const controller = new AbortController();
      const timer = window.setTimeout(() => controller.abort(), timeout);
      try {
        const response = await fetch(url, {
          method: 'GET',
          mode: 'cors',
          credentials: 'omit',
          headers: { Accept: 'application/json' },
          signal: controller.signal
        });
        if (!response.ok) throw new Error(`Request failed with status ${response.status}.`);
        return await response.json();
      } finally {
        window.clearTimeout(timer);
      }
    }
  }

  if (!customElements.get(ELEMENT_NAME)) customElements.define(ELEMENT_NAME, GloProviderLocator);
})();

  } catch(e) { console.error(e); }
})();
})();
